import { render, staticRenderFns } from "./AssuranceInfos.vue?vue&type=template&id=804073e0&scoped=true&"
import script from "./AssuranceInfos.vue?vue&type=script&lang=js&"
export * from "./AssuranceInfos.vue?vue&type=script&lang=js&"
import style0 from "./AssuranceInfos.vue?vue&type=style&index=0&id=804073e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804073e0",
  null
  
)

export default component.exports